<template>
  <div class="select-occupation">
    <div class="container">
      <div class="row">
        <div class="col-12  mx-auto text-right">
          <p class="text-gray" style="display:inline;">{{$t("message.select_ouccupation")}}{{$t("message.do")}} :</p>
          <div class="active occupationWrap">
              <b-form-select v-model="occupation" :options="options" class="selectOccupation text-right"></b-form-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';
export default {
  data () {
    return {
      occupation: undefined,
      options: [],
      idToken: localStorage.idToken
    }
  },
  methods: {
    makeOccupation(){
      this.options = []
      this.occupation = this.memberInfo.current_industry
      var interested_list = []
      if (this.memberInfo.interested_list != [] || this.memberInfo.interested_list != undefined){
        interested_list = this.memberInfo.interested_industry.toString().split(',')
      }
      for(var item of interested_list){
        this.options.push({value: item, text: this.$i18n.t('message.industry_id_' + item)})
      }
      //axios
      // .get(process.env.VUE_APP_API + "/users/" + this.memberInfo.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      // .then((res) => {
      //    this.options = []
      //    var user = res.data
      //    var interested_list = user.interested_industry.toString().split(',')

      //    for(var item of interested_list){
      //      this.options.push({value: item, text: this.$i18n.t('message.industry_id_' + item)})
      //    }
      // }).catch(error => {
      //   console.log('this is error', error)
      // })

    }
  },
  mounted() {
    this.makeOccupation()
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        outh: state => state.user.outh
    })
  },
  watch:{
    memberInfo(val){
      this.occupation = val.current_industry
      this.makeOccupation()
    },
    occupation(val, old){
      if(val != 0 && val != undefined && val != old){
        this.idToken = this.outh.signInUserSession.accessToken.jwtToken
        axios
         .patch(process.env.VUE_APP_API + "/users/" + this.memberInfo.id,{user: {current_industry: val}},{headers: {'Authorization': 'Bearer ' + this.idToken}})
         .then(() => {
           this.$store.commit('user/setOccupation', val)
           this.makeOccupation()
         }).catch(error => {
           console.log('this is error', error)
         })
      }
    },
    '$i18n.locale'(){
      this.makeOccupation()
    }
  }
}
</script>
<style scoped lang="scss">
.select-occupation {
  background-color: white !important;
}
</style>
